<div class="filter-table"  >
  <div *ngIf="!waitingDetail" class="tw-w-full tw-max-w-xs tw-mb-3">
    <div class="tw-relative">
      <div class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-pointer-events-none">
        <svg class="tw-w-4 tw-h-4 tw-text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
        </svg>
      </div>
      <input
        type="search"
        class="tw-block tw-w-full tw-p-2 tw-pl-10 tw-text-sm tw-text-gray-900 tw-border tw-border-gray-300 tw-rounded-lg tw-bg-gray-50"
        [placeholder]="('commons.search' | translate)"
        (keyup)="applyFilter($event.target.value)">
    </div>
  </div>

  <div class="area_table" [ngStyle]="tableAreaStyle">
    <mat-table  class="table-mh sticky centered-header centered-content" [ngStyle]="tableContentStyle" [class.invisible]="waitingDetail" #table [dataSource]="dataSource" [matSortActive]="firstColumn" matSortDisableClear matSortDirection="asc" matSort>

      <ng-container *ngFor="let key of headerTable; let i=index; trackBy: trackByKey" [matColumnDef]="key" [sticky]="i === 0">
        <mat-header-cell *matHeaderCellDef mat-sort-header  [class.first]="i===0">
          {{ (i===0 ? (typeCustomer | translate ) : key) }}
        </mat-header-cell>

        <mat-cell *matCellDef="let element" [class.first]="i===0">
          <ng-container [ngSwitch]="key">
            <ng-template [ngSwitchCase]="i===0 ? key : false">
              <div class="first-column">
                {{element[key]}}
              </div>
            </ng-template>
            <ng-template ngSwitchDefault>
              {{element[key] | formatBy: formatBy}}
            </ng-template>
          </ng-container>
        </mat-cell>

        <ng-container *ngIf="showTotals">

          <mat-footer-cell [class.first]="i===0" *matFooterCellDef>
            <div class="tw-w-full tw-text-center" [ngSwitch]="key">
              <ng-template [ngSwitchCase]="i===0 ? key : false">
                <div class="tw-text-left">
                  <b>{{'commons.'+totalBy | translate }}</b>
                </div>
              </ng-template>

              <ng-template ngSwitchDefault>
                {{totals[key] | formatBy: formatBy}}
              </ng-template>
            </div>
          </mat-footer-cell>
        </ng-container>

      </ng-container>
      <mat-header-row *matHeaderRowDef="headerTable; sticky: true"></mat-header-row>
      <mat-row [class.pointer]="showDetail" *matRowDef="let row; columns: headerTable;" (click)="showDetail ? openDialog(row) : null"></mat-row>
      <ng-container *ngIf="showTotals">
        <mat-footer-row *matFooterRowDef="headerTable; sticky: true"></mat-footer-row>
      </ng-container>
    </mat-table>
  </div>

</div>

<ng-template #confirmModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <i class="close far fa-times" (click)="closeDialog()"></i>
    <h4 class="title">{{'commons.details' | translate }}</h4>
  </div>

  <div class="modal-body">
    <div class="dialog_options">
      <div class="content-detail">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</ng-template>
